import { IEditableRecord } from '../../services/batch-edit-service/batch-edit-service';
import { SorterColumnDataType } from '../sorter-column-data-type.constant';

export const studentEditableMap = {
  _id: 'id',
  gradPlanningDetails: 'Graduation planning details',
  'gradPlanningDetails.plannedCreds': 'Planned Credentials',
  'gradPlanningDetails.plannedDiplomaType': 'Diploma Type',
  'gradPlanningDetails.plannedEndorsements': ' Planned Endorsements',
  'gradPlanningDetails.plannedGraduationDate': 'Graduation Date',
  'gradPlanningDetails.schoolVerifiedSafetyNetEligibility': 'Safety Net Eligibility',
  schoolPriorityGrouping: 'School Priority Grouping',
  schoolRiskGroupELA: 'School Risk Group (ELA)',
  schoolRiskGroupMath: 'School Risk Group (Math)',
  activeStudentSupports: 'Active Supports',
  nextScheduledRegents: 'Next scheduled regents',
  'nextScheduledRegents.global': 'Next scheduled Global History exam',
  'nextScheduledRegents.global.adminDate': 'Next scheduled Global History date',
  'nextScheduledRegents.global.examLanguage': 'Next scheduled Global History exam language',
  'nextScheduledRegents.us': 'Next scheduled US History exam',
  'nextScheduledRegents.us.adminDate': 'Next scheduled US History date',
  'nextScheduledRegents.us.examLanguage': 'Next scheduled US History exam language',
  'nextScheduledRegents.compEla': 'Next scheduled Comprehensive English Regents exam',
  'nextScheduledRegents.compEla.adminDate': 'Next scheduled Comprehensive English Regents date',
  'nextScheduledRegents.compEla.examLanguage': 'Next scheduled Comprehensive English Regents exam language',
  'nextScheduledRegents.ccEla': 'Next scheduled Common Core English Regents exam',
  'nextScheduledRegents.ccEla.adminDate': 'Next scheduled Common Core English Regents date',
  'nextScheduledRegents.ccEla.examLanguage': 'Next scheduled Common Core English Regents exam language',
  'nextScheduledRegents.intAlg': 'Next scheduled Integrated Algebra Regents exam',
  'nextScheduledRegents.intAlg.adminDate': 'Next scheduled Integrated Algebra Regents date',
  'nextScheduledRegents.intAlg.examLanguage': 'Next scheduled Integrated Algebra Regents exam language',
  'nextScheduledRegents.ccAlg': 'Next scheduled Common Core Algebra Regents exam',
  'nextScheduledRegents.ccAlg.adminDate': 'Next scheduled Common Core Algebra Regents date',
  'nextScheduledRegents.ccAlg.examLanguage': 'Next scheduled Common Core Algebra Regents exam language',
  'nextScheduledRegents.oldGeom': 'Next scheduled Geometry Regents exam',
  'nextScheduledRegents.oldGeom.adminDate': 'Next scheduled Geometry Regents date',
  'nextScheduledRegents.oldGeom.examLanguage': 'Next scheduled Geometry Regents exam language',
  'nextScheduledRegents.ccGeom': 'Next scheduled Common Core Geometry Regents exam',
  'nextScheduledRegents.ccGeom.adminDate': 'Next scheduled Common Core Geometry Regents date',
  'nextScheduledRegents.ccGeom.examLanguage': 'Next scheduled Common Core Geometry Regents exam language',
  'nextScheduledRegents.oldTrig': 'Next scheduled Trigonometry Regents exam',
  'nextScheduledRegents.oldTrig.adminDate': 'Next scheduled Trigonometry Regents date',
  'nextScheduledRegents.oldTrig.examLanguage': 'Next scheduled Trigonometry Regents exam language',
  'nextScheduledRegents.ccTrig': 'Next scheduled Common Core Trigonometry Regents exam',
  'nextScheduledRegents.ccTrig.adminDate': 'Next scheduled Common Core Trigonometry Regents date',
  'nextScheduledRegents.ccTrig.examLanguage': 'Next scheduled Common Core Trigonometry Regents exam language',
  'nextScheduledRegents.livingEnv': 'Next scheduled Living Environment Regents exam',
  'nextScheduledRegents.livingEnv.adminDate': 'Next scheduled Living Environment Regents date',
  'nextScheduledRegents.livingEnv.examLanguage': 'Next scheduled Living Environment Regents exam language',
  'nextScheduledRegents.chem': 'Next scheduled Chemistrty Regents exam',
  'nextScheduledRegents.chem.adminDate': 'Next scheduled Chemistrty Regents date',
  'nextScheduledRegents.chem.examLanguage': 'Next scheduled Chemistrty Regents exam language',
  'nextScheduledRegents.physics': 'Next scheduled Physics Regents exam',
  'nextScheduledRegents.physics.adminDate': 'Next scheduled Physics Regents date',
  'nextScheduledRegents.physics.examLanguage': 'Next scheduled Physics Regents exam language',
  'nextScheduledRegents.earth': 'Next scheduled Earth Science Regents exam',
  'nextScheduledRegents.earth.adminDate': 'Next scheduled Earth Science Regents date',
  'nextScheduledRegents.earth.examLanguage': 'Next scheduled Earth Science Regents exam language',
  'nextScheduledRegents.lote': 'Next scheduled LOTE Regents exam',
  'nextScheduledRegents.lote.adminDate': 'Next scheduled LOTE Regents date',
  'nextScheduledRegents.lote.examLanguage': 'Next scheduled LOTE Regents exam language',
  studentContactDetails: 'Student contact details',
  'studentContactDetails.email': 'Student contact email',
  'studentContactDetails.mobile': 'Student contact mobile',
  'studentContactDetails.parentEmail': 'Student contact parent email',
  eopFinancialEligibility: 'EOP financial eligibility',
};

const validRiskGroupOptions = ['Pushable 2', 'Pushable 3', 'Slippable 2', 'Slippable 3'];

const validEopEligibilityOptions = ['Eligible', 'Not eligible'];

export interface IStudentEditableField extends IEditableRecord {
  path: string;
  type?: string;
}
//
export const studentEditableFieldMap = {
  primaryPointPerson: {
    humanName: 'Point person for all areas',
    path: 'pointPeople',
    category: 'POINT PEOPLE',
    schoolLevels: ['ES', 'MS', 'HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  attendancePointPerson: {
    humanName: 'Attendance point person',
    path: 'pointPeople',
    type: 'ATTENDANCE',
    category: 'POINT PEOPLE, ATTENDANCE',
    schoolLevels: ['ES', 'MS', 'HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  academicPointPerson: {
    humanName: 'Academic point person',
    path: 'pointPeople',
    type: 'ACADEMIC',
    category: 'ACADEMICS, POINT PEOPLE',
    schoolLevels: ['ES', 'MS', 'HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  postSecPointPerson: {
    humanName: 'Postsecondary point person',
    path: 'pointPeople',
    type: 'POSTSECONDARY',
    category: 'POINT PEOPLE, POSTSECONDARY',
    schoolLevels: ['HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  creditsPointPerson: {
    humanName: 'Credits point person',
    path: 'pointPeople',
    type: 'CREDITS',
    category: 'POINT PEOPLE, CREDITS',
    schoolLevels: ['HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  regentsPointPerson: {
    humanName: 'Regents point person',
    path: 'pointPeople',
    type: 'REGENTS',
    category: 'POINT PEOPLE, REGENTS',
    schoolLevels: ['HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  advisor: {
    humanName: 'Advisor',
    path: 'pointPeople',
    type: 'ADVISOR',
    category: 'POINT PEOPLE, BASIC INFO',
    schoolLevels: ['ES', 'MS', 'HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  guidanceCounselor: {
    humanName: 'Guidance Counselor',
    path: 'pointPeople',
    type: 'GUIDANCE_COUNSELOR',
    category: 'POINT PEOPLE, BASIC INFO',
    schoolLevels: ['ES', 'MS', 'HS'],
    editable: true,
    dataType: SorterColumnDataType.USER_MINI,
    dataTypeOptions: {
      canBeRemoved: true,
    },
  } as IStudentEditableField,
  schoolRiskGroupELA: {
    humanName: 'School Risk Group (ELA)',
    path: 'schoolRiskGroupELA',
    category: 'ACADEMICS',
    schoolLevels: ['ES', 'MS'],
    editable: true,
    dataType: SorterColumnDataType.ENUM,
    dataTypeOptions: {
      canBeNull: true,
      values: validRiskGroupOptions,
    },
  } as IStudentEditableField,
  schoolRiskGroupMath: {
    humanName: 'School Risk Group (Math)',
    path: 'schoolRiskGroupMath',
    category: 'ACADEMICS',
    schoolLevels: ['ES', 'MS'],
    editable: true,
    dataType: SorterColumnDataType.ENUM,
    dataTypeOptions: {
      canBeNull: true,
      values: validRiskGroupOptions,
    },
  } as IStudentEditableField,
  eopFinancialEligibility: {
    humanName: 'EOP financial eligibility',
    path: 'eopFinancialEligibility',
    editable: true,
    category: 'POSTSECONDARY',
    schoolLevels: ['HS'],
    dataType: SorterColumnDataType.ENUM,
    dataTypeOptions: {
      canBeNull: true,
      values: validEopEligibilityOptions,
    },
  } as IStudentEditableField,
};
